import { Datasource, Pipeline } from "@features/data-platform/types.ts";
import { createContext, useContext } from "react";
import { Chain, ChainDataType, Network } from "@util/constants.ts";

export enum PipelineModalAction {
  STOP,
}

export type DataPlatformModalContextData = {
  action: PipelineModalAction;
  pipelineID: number | string;
};

interface DataPlatformContextData {
  loading: boolean;
  loaded: boolean;
  modal: DataPlatformModalContextData | null;
  openModal: (action: PipelineModalAction, pipelineID: number | string) => void;
  closeModal: () => void;
  dataSources: Datasource[];
  pipelines: Pipeline[];
  refreshPipelines: () => Promise<void>;
  availableChains: Set<Chain> | undefined;
  availableNetworks: Set<Network> | undefined;
  availableDatatypesByNetwork:
    | Partial<Record<Network, Set<ChainDataType>>>
    | undefined;
}

export const DataPlatformContext = createContext<DataPlatformContextData>({
  loading: true,
  loaded: false,
  modal: null,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  openModal: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  closeModal: () => {},
  dataSources: [],
  pipelines: [],
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  refreshPipelines: async () => {},
  availableChains: undefined,
  availableNetworks: undefined,
  availableDatatypesByNetwork: undefined,
});

export const useDataPlatformContext = () => {
  return useContext(DataPlatformContext);
};

export const DataPlatformProvider = DataPlatformContext.Provider;
export const DataPlatformConsumer = DataPlatformContext.Consumer;
